import { CtaLink, Eyebrow, Reveal } from '../ui';

const cards = [
  { eyebrow: 'Newsletter', title: 'Restez informé', text: 'Recevez nos actualités, nos projets et nos bonnes pratiques directement par e-mail.', cta: "S'abonner", to: '#newsletter-email' },
  { eyebrow: 'Nos réalisations', title: 'Nos projets', text: 'Découvrez nos chantiers et la façon dont nous construisons, partout où nous intervenons.', cta: 'Voir les projets', to: '/portfolio' },
  { eyebrow: 'Contact', title: 'Parlons-en', text: 'Un projet de construction, de rénovation ou d’ingénierie ? Notre équipe vous répond.', cta: 'Nous contacter', to: '/contact' },
];

/** Bande « Explorer plus »: trois cartes blanches bordées, sur fond clair. */
export default function ExploreMore() {
  return (
    <section className="bg-surface py-16 md:py-20">
      <div className="site-container">
        <Eyebrow className="mb-10">Explorer plus</Eyebrow>
        <div className="grid gap-6 md:grid-cols-3">
          {cards.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div className="flex h-full flex-col border border-line bg-white p-8 md:p-10">
                <div className="text-xs font-normal uppercase tracking-[0.0625rem] text-ink">{c.eyebrow}</div>
                <h3 className="mt-3 font-sans text-[2rem] font-bold normal-case leading-tight tracking-normal text-black">{c.title}</h3>
                <p className="mt-4 flex-1 text-[1rem] leading-relaxed text-ink">{c.text}</p>
                <div className="mt-6">
                  {c.to.startsWith('#') ? (
                    <a href={c.to} onClick={(e) => { e.preventDefault(); document.getElementById('newsletter-email')?.focus(); document.getElementById('newsletter-email')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); }} className="group inline-flex items-center gap-3 py-1 text-[0.875rem] font-semibold uppercase tracking-[0.094rem] text-charcoal hover:text-brand-dark">
                      {c.cta}<span aria-hidden className="h-px w-6 bg-brand transition-all duration-300 group-hover:w-14" />
                    </a>
                  ) : <CtaLink to={c.to}>{c.cta}</CtaLink>}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
